import React from "react";
import { Button } from "components";

const ButtonPair = ({
  continueLabel,
  loading,
  onPreviousClick,
  disableContinue,
}) => {
  return (
    <div
      className="d-flex justify-content-between"
      style={{ marginTop: "4rem" }}
    >
      <Button
        variant="secondary"
        disabled={loading}
        label="Back"
        size="xs"
        onClick={onPreviousClick}
      />
      <Button
        label={continueLabel || "Save"}
        size="xs"
        type="submit"
        disabled={disableContinue}
        loading={loading}
      />
    </div>
  );
};

export default ButtonPair;
